// extracted by mini-css-extract-plugin
export default {"root":"promo-modal_root__lbuAX","title":"promo-modal_title__tES4X","content":"promo-modal_content__4LXYw","label":"promo-modal_label__nJztL","applied":"promo-modal_applied__K2GHH"};